module.exports = __webpack_public_path__ + "static/media/angularjs-plain.80c44b64.svg";